import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // list
    fetchStages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/stages", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/project_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectBookingStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/project_booking_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectDocumentTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/project_document_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectCommentTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/project_comment_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchActivityTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/activity_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // show fetch specifi
    fetchStage(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/stages/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/project_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectBookingStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/project_booking_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectDocumentType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/project_document_types/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProjectCommentType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/project_comment_types/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchActivityType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/activity_types/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // store
    editStage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/stages", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProjectStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/project_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProjectBookingStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/project_booking_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProjectDocumentType(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/project_document_types", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProjectCommentType(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/project_comment_types", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editActivityType(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/activity_types", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },


    // delete
    deleteStage(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/stages", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/project_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectBookingStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/project_booking_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectDocumentType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/project_document_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectCommentType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/project_comment_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteActivityType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/activity_types", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
